// extracted by mini-css-extract-plugin
export var banner = "contact-module--banner--xGgvK";
export var contact_static_hide = "contact-module--contact_static_hide--TzSgy";
export var googlecontainer = "contact-module--googlecontainer--J39qc";